import { render, staticRenderFns } from "./InpekelItemCombo.vue?vue&type=template&id=36b5d894&scoped=true"
import script from "./InpekelItemCombo.vue?vue&type=script&lang=js"
export * from "./InpekelItemCombo.vue?vue&type=script&lang=js"
import style0 from "./InpekelItemCombo.vue?vue&type=style&index=0&id=36b5d894&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b5d894",
  null
  
)

export default component.exports